import React from 'react';
import TrackDetailsCard from '../../../../../components/cards/TrackDetailsCard';
import TrailResultCard from '../../../../../components/cards/TrailResultCard';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';
import { PhotosTab } from '../../track_show/photos_tab';
import { ServerCommunicationUtil } from '../../../../../utils/server_communication_util';
import { SplitsTab } from '../../track_show/splits_tab';
import { StatsTab } from '../../track_show/stats_tab';
import { StringConstantsMixin } from '../../mixins/shared/string_constants_mixin';
import { TrackOverview } from '../../track_show/track_overview';
import { getFormattedTrailUrls } from '../../../../../utils/trail_helpers';

const createReactClass = require('create-react-class');

const FullscreenTrackDetails = createReactClass({
  getInitialState() {
    let hidden = null;
    let hideStatusText = null;
    if (this.props.context.adminUser) {
      hidden = this.props.data.hidden;
      hideStatusText = this.props.data.hidden ? StringConstantsMixin.strings.TRACK_DETAIL.UNHIDE : StringConstantsMixin.strings.TRACK_DETAIL.HIDE;
    }
    return {
      hidden,
      hideStatusText
    };
  },
  handlePhotosUpload(photos) {
    if (this.props.handlePhotosUpload) this.props.handlePhotosUpload(photos);
  },
  handleTrackDefaultPhotoChanged(photoId) {
    if (this.props.handleTrackDefaultPhotoChanged) this.props.handleTrackDefaultPhotoChanged(photoId);
  },
  handleDescriptionSubmit(newDescription) {
    const updateMapUrl = `/api/alltrails/maps/${this.props.data.id}?detail=deep&key=${ServerCommunicationUtil.apiKey}`;
    const mapDescriptionEditText = this.refs.trackOverview.refs.mapDescription.refs.textEditItem;
    ServerCommunicationUtil.putApiEndpoint(
      updateMapUrl,
      { map: { description: newDescription } },
      mapDescriptionEditText.submitSuccess,
      mapDescriptionEditText.submitError,
      mapDescriptionEditText.submitComplete
    );
  },
  handleRefreshSubmit(data, callback) {
    ServerCommunicationUtil.getApiEndpoint(
      `/api/alltrails/maps/${data.id}/refresh_map_cache`,
      {},
      function() {
        callback();
      },
      function(err) {
        console.log(err);
      },
      function() {}
    );
  },
  handleFindLocationSelect(feature) {
    const { latitude, longitude } = feature;
    this.props.messagingChannel.publish({
      topic: 'edit.change_lat_lng',
      data: [latitude, longitude, 14]
    });
  },
  handleTrailClick(trail) {
    const { localizedUrl } = getFormattedTrailUrls(trail, this.props.context);
    window.open(localizedUrl, '_blank');
    return false;
  },
  handleAddAsTrailClick(e) {
    e.preventDefault();
    e.stopPropagation();
    window.open(LanguageSupportUtil.wrapUrlSafe(`/trail/new?recording=${this.props.data.id}`, this.props.context.languageRegionCode), '_blank');
  },
  handleHideShowTrackClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const url = `/api/alltrails/maps/${this.props.data.id}/metadata`;
    const hidden = !this.state.hidden;
    const data = {
      hidden
    };
    this.setState({ hideStatusText: hidden ? 'Hiding' : 'Unhiding' });
    ServerCommunicationUtil.postApiEndpoint(
      url,
      data,
      function() {
        this.setState({
          hidden,
          hideStatusText: hidden ? StringConstantsMixin.strings.TRACK_DETAIL.UNHIDE : StringConstantsMixin.strings.TRACK_DETAIL.HIDE
        });
      }.bind(this),
      function() {
        this.setState({
          hideStatusText: StringConstantsMixin.strings.FAILED
        });
      }.bind(this),
      function() {}
    );
  },
  getSource() {
    if (!this.props.data || !this.props.data.metadata || !this.props.data.metadata.source) {
      return '?';
    }
    switch (this.props.data.metadata.source) {
      case 1000:
        return 'iOS';
      case 1001:
        return 'Android';
      case 1043:
        return 'Garmin';
      case 1033:
        return 'Web';
      default:
        return 'Other';
    }
  },
  renderOverview() {
    const canEdit =
      !this.props.isMobileWidth &&
      ((this.props.context.currentUser && (this.props.data.user.id == this.props.context.currentUser.id || this.props.context.adminUser)) ||
        this.props.data.user == null ||
        this.props.data.user.username == StringConstantsMixin.constants.MAGIC.ANONYMOUS_MAP_USERNAME);
    return (
      <TrackOverview
        ref="trackOverview"
        data={this.props.data}
        result={this.props.result}
        canEdit={canEdit}
        handleDescriptionSubmit={this.handleDescriptionSubmit}
        handleMapInfoChanged={this.props.handleMapInfoChanged}
        getMapViewCenter={this.props.getMapViewCenter}
        handleMapUpdate={this.props.handleMapUpdate}
        messagingChannel={this.props.messagingChannel}
        currentUser={this.props.context.currentUser}
      />
    );
  },
  renderPhotosTab() {
    const canEditTrackOverview =
      !this.props.isMobileWidth &&
      ((this.props.context.currentUser && (this.props.data.user.id == this.props.context.currentUser.id || this.props.context.adminUser)) ||
        (!this.props.context.currentUser && this.props.data.user == null));
    if ((canEditTrackOverview || this.props.data.user != null) && this.props.data.id) {
      return (
        <PhotosTab
          openTrailFormModal={this.props.openTrailFormModal}
          track={this.props.data}
          data={this.props.data.mapPhotos}
          handlePhotosUpload={this.handlePhotosUpload}
          messagingChannel={this.props.messagingChannel}
          currentUser={this.props.context.currentUser}
          forceReload
        />
      );
    }
    return null;
  },
  render() {
    const style = { display: 'block', height: '100%', bottom: 0, left: 0 };
    let addAsTrail = null;
    let hideShowTrack = null;
    // do not show any of these options if user is on mobile
    if (!this.props.context.mobileBrowser && this.props.context.currentUser && !this.props.data.private) {
      addAsTrail = (
        <a className="add-track-as-trail link" onClick={this.handleAddAsTrailClick}>
          {this.props.context.adminUser ? StringConstantsMixin.strings.ADD : StringConstantsMixin.strings.SUGGEST}{' '}
          {StringConstantsMixin.strings.TRACK_DETAIL.AS_NEW_TRAIL}
        </a>
      );
      if (this.props.context.adminUser && this.state.hideStatusText !== null) {
        hideShowTrack = (
          <a className="add-track-as-trail link" onClick={this.handleHideShowTrackClick}>
            {this.state.hideStatusText}
          </a>
        );
      }
    }
    let trailCard;
    if (this.props.trackTrail) {
      const itemID = `www.alltrails.com/${this.props.trackTrail.slug}`;
      const result = this.props.trackTrail;
      trailCard = (
        <div id="trail-card" className="inline-card" itemProp="containedInPlace" itemScope itemType="http://schema.org/LocalBusiness" itemID={itemID}>
          <span className="associated-with-trail">{StringConstantsMixin.strings.TRACK_DETAIL.LINKED_TRAIL}</span>
          {addAsTrail}
          {hideShowTrack}
          <TrailResultCard
            allowClickingCompletedBadge={this.props.resultCardFunctions.allowClickingCompletedBadge(result.type, result.ID)}
            context={this.props.context}
            handleCardClick={() => this.props.resultCardFunctions.handleTrailClick(result)}
            handleCompletedBadgeClick={() => this.props.resultCardFunctions.handleCompletedBadgeClick(result.type, result.ID)}
            handleFavoriteClick={() => this.props.resultCardFunctions.handleFavoriteClick(result.type, result.ID)}
            handleLocationClick={this.props.resultCardFunctions.handleLocationClick}
            isCompleted={this.props.resultCardFunctions.isItemCompleted(result.type, result.ID)}
            isFavorite={this.props.resultCardFunctions.isItemFavorited(result.type, result.ID)}
            isMobileWidth={this.props.isMobileWidth}
            isVerified={this.props.resultCardFunctions.isItemVerified(result.type, result.ID)}
            key={`trail-${result.ID}`}
            messagingChannel={this.props.messagingChannel}
            showFavoriteHeart={this.props.resultCardFunctions.showFavoriteHeart(result.type, result.ID)}
            tabletBrowser={this.props.context.tabletBrowser}
            trail={result}
          />
        </div>
      );
    } else if (addAsTrail != null) {
      style.paddingBottom = '30px';
      trailCard = (
        <div id="trail-card" className="caption-only">
          {addAsTrail}
          {hideShowTrack}
        </div>
      );
    }

    const statsTab = (
      <StatsTab
        data={this.props.data}
        currentPage={this.props.currentPage}
        isMobileWidth={this.props.isMobileWidth}
        displayMetric={this.props.context.displayMetric}
        handleRefreshSubmit={this.handleRefreshSubmit}
        handleShareClick={this.props.handleShareClick}
        currentUser={this.props.context.currentUser}
        messagingChannel={this.props.messagingChannel}
        languageRegionCode={this.props.context.languageRegionCode}
      />
    );

    const { result } = this.props;
    return (
      <div id="fullscreen-track-details" style={style}>
        <div className="inner-track-details">
          <TrackDetailsCard
            context={this.props.context}
            forcePhotoId={this.props.resultCardFunctions.forcePhotoId(result.type, result.ID)}
            handleFavoriteClick={() => this.props.resultCardFunctions.handleFavoriteClick(result.type, result.ID)}
            height={180}
            isFavorite={this.props.resultCardFunctions.isItemFavorited(result.type, result.ID)}
            isMobileWidth={this.props.isMobileWidth}
            key={`track-${this.props.result.ID}`}
            linkable={false}
            messagingChannel={this.props.messagingChannel}
            showEditLink={
              (this.props.context.currentUser &&
                result.user &&
                (result.user.id === this.props.context.currentUser.id || this.props.context.currentUser.admin)) ||
              (!this.props.context.currentUser && result.user && result.user.slug === StringConstantsMixin.constants.MAGIC.ANONYMOUS_MAP_USERNAME)
            }
            showFavoriteHeart
            showStaticMap={false}
            tabletBrowser={this.props.context.tabletBrowser}
            track={result}
            width={396}
          />
          {statsTab}
          <SplitsTab
            source={this.getSource()}
            splits={this.props.data.splits}
            displayMetric={this.props.context.displayMetric}
            currentUser={this.props.context.currentUser}
          />
          {this.renderOverview()}
          {this.renderPhotosTab()}
          {trailCard}
        </div>
      </div>
    );
  }
});

export { FullscreenTrackDetails };
